import React, { useState, useEffect } from "react";
import { MDBBtn, MDBRow } from "mdb-react-ui-kit";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import Autocomplete from "@mui/material/Autocomplete";
import Skeleton from "@mui/material/Skeleton";
import { Link } from "react-router-dom";
import InputMask from "react-input-mask";
import axios from "axios";
//
import { validate } from "../components/login/validate";
// config
import configData from "../config/config.json";
// components
import MetaTagsBusinessOwners from "../components/meta-tags-seo/MetaTagsBusinessOwners";
import RegisterBusiness from "./RegisterBusiness";
import DraggableMap from "../components/draggable-map/DraggableMap";
// img
import imgg from "../images/register-business/044.png";
import iconn from "../images/next-left.png";

// rtl
const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const RegisterBusinessStep3 = (props) => {
  const formatChar = {
    0: "[0-9]",
    a: "[A-Za-z]",
    "*": "[A-Za-z0-9]",
  };

  const [dataCome, setDataCome] = useState(false);
  const [render, setRender] = useState(false);

  const [disable, setDisable] = useState(false);

  const [PostalCode, setPostalCode] = useState("");
  const [PhoneCode, setPhoneCode] = useState("");

  // data
  const [data, setData] = useState({
    country: "",
    province: 0,
    city: 0,
    AddressLine1: "",
    PostalCode: "",
    AddressLine2: "",
  });

  // location data
  const [locationData, setLocationData] = useState({
    Lat: "",
    Lng: "",
  });
  const [zoom, setZoom] = useState(3);
  // zoomCenter
  const [zoomCenter, setZoomCenter] = useState({
    Lat: "",
    Lng: "",
  });
  // map loading
  const [mapLoading, setMapLoading] = useState("");
  // map border
  const [mapBorder, setMapBorder] = useState(false);

  const [valueCountry, setValueCountry] = useState(null);
  const [inputValueCountry, setInputValueCountry] = useState("");
  const [valueProvince, setValueProvince] = useState(null);
  const [inputValueProvince, setInputValueProvince] = useState("");
  const [valueCity, setValueCity] = useState(null);
  const [inputValueCity, setInputValueCity] = useState("");

  const [inputDisable, setInputDisable] = useState(true);

  const [Countries, setCountries] = useState([]);
  const [Provinces, setProvinces] = useState([]);
  const [Cities, setCities] = useState([]);

  const [CountryId, setCountryId] = useState("");
  const [ProvinceId, setProvinceId] = useState("");
  // const inputChangeHandler = (event, newValue) => {
  //   // setValue(newValue.);
  //   setCountryId(newValue.CId);
  //   setPostalCode(newValue.PostalStd);
  //   setPhoneCode(newValue.PhoneStd);
  // };
  // const inputInputChangeHandler = (event, newInputValue) => {
  //   // setInputValue(newInputValue);
  //   setData({ ...data, country: newInputValue });
  // };

  // validate
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  useEffect(() => {
    setErrors(validate(data, "register-business-s4"));
  }, [data, touched]);

  const [ErrorPostalCode, setErrorPostalCode] = useState("");
  const CheckAddress = (event) => {
    setData({ ...data, AddressLine1: event.target.value });
  };
  const PostalHandeler = (event) => {
    setData({ ...data, PostalCode: event.target.value });
  };

  useEffect(() => {
    if (!data.PostalCode.includes("_")) {
      // console.log("no error");
      setErrorPostalCode("");
    } else if (data.PostalCode.includes("_")) {
      setErrorPostalCode("لطفا کد پستی خود را صحیح وارد کنید .");
      // console.log("yes error");
    }
  }, [data.PostalCode]);

  const ErrorPostalCodeFunc = () => {
    // console.log(data.PostalCode.includes("_"));
    // console.log(data.PostalCode);
    if (data.AddressLine1 !== "" && data.PostalCode === "") {
      // console.log("11-");

      setErrorPostalCode("لطفا کد پستی خود را وارد کنید .");
    } else if (data.PostalCode.includes("_")) {
      // console.log("21-");

      setErrorPostalCode("لطفا کد پستی خود را صحیح وارد کنید .");
    } else {
      setErrorPostalCode("");
      // console.log("31-");
    }
  };
  //

  // header
  const header = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Authorization: "Bearer " + getCookie("token"),
  };

  const submitHandler = (event) => {
    event.preventDefault();

    ErrorPostalCodeFunc();

    // const itemsPost1 = getCookie("OwnerId");
    var itemsPost2;
    var itemsPost3;
    if (valueCity == null) {
      itemsPost2 = 0;
    } else {
      itemsPost2 = valueCity.id;
    }
    if (valueProvince == null) {
      itemsPost3 = 0;
    } else {
      itemsPost3 = ProvinceId;
    }

    const dataPost = {
      // LangId: 1,
      // OwnerId: itemsPost1,

      bId: getCookie("BizId"),
      countryId: parseInt(CountryId),
      provinceId: itemsPost3 == "" ? 0 : itemsPost3,
      cityId: itemsPost2 == "" ? 0 : itemsPost2,
      postalCode: data.PostalCode,
      addressLine1: data.AddressLine1,
      addressLine2: data.AddressLine2,
      lat: locationData.Lat != "" ? locationData.Lat : 0,
      lng: locationData.Lng != "" ? locationData.Lng : 0,
    };

    if (
      !Object.keys(errors).length &&
      data.AddressLine1 === "" &&
      ErrorPostalCode == ""
    ) {
      setDisable(true);
      axios
        .post(
          configData.API_DOMAIN +
            `/api/v1/Businesses/${getCookie("BizUuid")}/addresses`,
          dataPost,
          {
            headers: header,
          }
        )
        .then((response) => {
          setDisable(false);
          if (response.data.isSuccess) {
            // success
            localStorage.setItem(
              "phonestd",
              JSON.stringify(valueCountry.phoneStd)
            );
            localStorage.setItem(
              "postalstd",
              JSON.stringify(valueCountry.postalStd)
            );
            localStorage.setItem(
              "PrefixCode",
              JSON.stringify(valueCountry.prefixCode)
            );

            localStorage.setItem("CountryId", JSON.stringify(valueCountry.id));

            if (valueProvince == null) {
              localStorage.setItem("ProvinceId", JSON.stringify(0));
            } else {
              localStorage.setItem(
                "ProvinceId",
                JSON.stringify(valueProvince.Id)
              );
            }
            if (valueCity == null) {
              itemsPost2 = 0;
              localStorage.setItem("CityId", JSON.stringify(0));
            } else {
              localStorage.setItem("CityId", JSON.stringify(valueCity.Id));
            }

            localStorage.setItem("AId", JSON.stringify(response.data.data.aId));

            localStorage.removeItem("step4-back-data"); // remove data of step4 saved by back button

            props.history.push({
              pathname: "/register-business-step5",
              state: PhoneCode,
            });
          }
        })
        .catch((error) => {
          // alert(error);
        });
    } else if (
      !Object.keys(errors).length &&
      data.AddressLine1 !== "" &&
      data.PostalCode !== "" &&
      ErrorPostalCode == ""
    ) {
      setDisable(true);

      axios
        .post(
          configData.API_DOMAIN +
            `/api/v1/Businesses/${getCookie("BizUuid")}/addresses`,
          dataPost,
          {
            headers: header,
          }
        )
        .then((response) => {
          setDisable(false);

          if (response.data.isSuccess) {
            // success
            localStorage.setItem(
              "phonestd",
              JSON.stringify(valueCountry.phoneStd)
            );
            localStorage.setItem(
              "postalstd",
              JSON.stringify(valueCountry.postalStd)
            );
            localStorage.setItem(
              "PrefixCode",
              JSON.stringify(valueCountry.prefixCode)
            );

            localStorage.setItem("CountryId", JSON.stringify(valueCountry.id));

            if (valueProvince == null) {
              localStorage.setItem("ProvinceId", JSON.stringify(0));
            } else {
              localStorage.setItem(
                "ProvinceId",
                JSON.stringify(valueProvince.Id)
              );
            }
            if (valueCity == null) {
              itemsPost2 = 0;
              localStorage.setItem("CityId", JSON.stringify(0));
            } else {
              localStorage.setItem("CityId", JSON.stringify(valueCity.Id));
            }

            localStorage.setItem("AId", JSON.stringify(response.data.data.aId));

            localStorage.removeItem("step4-back-data"); // remove data of step4 saved by back button

            props.history.push({
              pathname: "/register-business-step5",
              state: PhoneCode,
            });
          }
        })
        .catch((error) => {
          // alert(error);
        });
    } else {
      setTouched({
        country: true,
      });
    }
  };

  const backHandler = () => {
    const dataLocal = {
      address: {
        addressLine1: data.AddressLine1,
        addressLine2: data.AddressLine2,
        lat: locationData.Lat != "" ? locationData.Lat : 0,
        lng: locationData.Lng != "" ? locationData.Lng : 0,
        postalCode: data.PostalCode,
      },

      valueCountry: valueCountry,
      valueProvince: valueProvince,
      valueCity: valueCity,
    };

    localStorage.setItem("step4-back-data", JSON.stringify(dataLocal)); //set step4 loocal storage

    props.history.push({
      pathname: "/register-business-step3",
    });
  };

  // this 2 satae for Meta Tags
  const [MTagsCome, setMTagsCome] = useState(false);
  const [MetaData, setMetaData] = React.useState({});

  //api header
  const headerMeta = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Page: "register-business-step4",
    Authorization: "Bearer " + getCookie("token"),
  };

  // api
  useEffect(() => {
    setDataCome(false);
    let OwnerIdCookie = getCookie("OwnerId");
    if (!OwnerIdCookie) {
      props.history.push({
        pathname: "/login",
      });
    } else {
      setMapLoading(false);
      // comment for come data from mina -- check api
      // axios
      //   .get(configData.API_DOMAIN + "/api/biz/register/check-complete", {
      //     headers: {
      //       ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
      //       LangId: 1,
      //       OwnerId: OwnerIdCookie,
      //       BizId: getCookie("BizId"),
      //     },
      //   })
      //   .then((response) => {
      //     if (response.data.msg == "not-registered") {
      //       props.history.push({
      //         pathname: "/signup",
      //       });
      //     } else if (response.data.msg == "done") {
      //       if (response.data.IsComplete) {
      //         props.history.push({
      //           pathname: "/business-dashboard",
      //         });
      //       } else if (response.data.RegStep < 4) {
      //         props.history.push({
      //           pathname: `/register-business-step${response.data.RegStep}`,
      //         });
      //       } else {
      // comment for come data from mina -- check api

      // api for meta tags
      axios
        .get(configData.API_DOMAIN + "/api/v1/MetaTags/businessOwner", {
          headers: headerMeta,
        })
        .then((response) => {
          if (response.data.isSuccess) {
            setMTagsCome(true);
            setMetaData(response.data.data);
          }
        })
        .catch((error) => {
          // alert(error);
        });

      // api to check and get data
      axios
        .get(
          configData.API_DOMAIN +
            `/api/v1/Businesses/${getCookie("BizUuid")}/addresses`,
          {
            headers: {
              ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
              LangId: 1,
              Authorization: "Bearer " + getCookie("token"),
            },
          }
        )
        .then((response) => {
          if (response.data.isSuccess) {
            let stepStatus = response.data.data.stepStatus;
            let data = response.data.data;

            // check user is registered or not
            if (!stepStatus.isRegistered) {
              props.history.push({
                pathname: "/signup",
              });
            }
            // check the business steps are completed or not
            else if (stepStatus.isComplete) {
              props.history.push({
                pathname: "/business-dashboard",
              });
            }
            // check the business step number -- comment for step 1
            else if (stepStatus.regStep < 4) {
              props.history.push({
                pathname: `/register-business-step${stepStatus.regStep}`,
              });
            } else {
              let x = response.data.data;

              if (JSON.parse(localStorage.getItem("step4-back-data"))) {
                // set data from local storage to states
                x = JSON.parse(localStorage.getItem("step4-back-data"));
              } else {
                // set data from api to states
                x = response.data.data;
              }

              // set data to states
              setDataCome(true);
              // setMapLoading(true);

              setData({
                ...data,
                AddressLine1: x.address.addressLine1,
                AddressLine2: x.address.addressLine2,
                PostalCode: x.address.postalCode,
                country: x.valueCountry ? x.valueCountry.title : "",
                province: x.valueProvince ? x.valueProvince.title : "",
                city: x.valueCity ? x.valueCity.title : "",
              });

              if (x.valueCountry) {
                setInputDisable(false);
                setValueCountry(x.valueCountry);
                setCountryId(x.valueCountry.id);
                setPostalCode(x.valueCountry.postalStd);
                setPhoneCode(x.valueCountry.phoneStd);

                // api to get list of countries
                axios
                  .get(configData.API_DOMAIN + "/api/v1/Countries", {
                    headers: header,
                  })
                  .then((response) => {
                    if (response.data.isSuccess) {
                      setCountries(response.data.data);
                    } else {
                      setCountries([]);
                    }
                  })
                  .catch((error) => {
                    // alert(error);
                  });

                axios
                  .get(
                    configData.API_DOMAIN +
                      `/api/v1/Provinces/${x.valueCountry.id}`,
                    {
                      headers: {
                        ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
                        LangId: 1,
                        Authorization: "Bearer " + getCookie("token"),
                      },
                    }
                  )
                  .then((response) => {
                    if (response.data.isSuccess) {
                      setProvinces(response.data.data);
                    } else {
                      setProvinces([]);
                    }
                  })
                  .catch((error) => {
                    // alert(error);
                  });

                if (x.valueProvince && x.valueProvince.title != null) {
                  setValueProvince(x.valueProvince);
                  setProvinceId(x.valueProvince.id);
                  axios
                    .get(
                      configData.API_DOMAIN +
                        `/api/v1/Cities/${x.valueProvince.id}`,
                      {
                        headers: {
                          ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
                          LangId: 1,
                          Authorization: "Bearer " + getCookie("token"),
                        },
                      }
                    )
                    .then((response) => {
                      if (response.data.isSuccess) {
                        setCities(response.data.data);
                      } else {
                        setCities([]);
                      }
                    })
                    .catch((error) => {
                      // alert(error);
                    });
                  if (x.valueCity && x.valueCity.title != null) {
                    setValueCity(x.valueCity);
                  }
                }
                // to show map pin
                if (x.address.lat !== 0 && x.address.lng !== 0) {
                  setLocationData({
                    Lat: x.address.lat,
                    Lng: x.address.lng,
                  });
                  setZoom(16);
                  setMapLoading(true);
                  // console.log(locationData);
                } else if (
                  x.valueCountry.title !== undefined &&
                  x.valueCountry.title !== null &&
                  x.valueCountry.title !== ""
                ) {
                  let url = `https://nominatim.openstreetmap.org/search.php?city=${
                    x.valueCity &&
                    x.valueCity.title !== undefined &&
                    x.valueCity.title !== null
                      ? x.valueCity.title
                      : ""
                  }
                  &county=&state=${
                    x.valueProvince &&
                    x.valueProvince.title !== undefined &&
                    x.valueProvince.title !== null
                      ? x.valueProvince.title
                      : ""
                  }&country=${
                    x.valueCountry.title !== undefined &&
                    x.valueCountry.title !== null
                      ? x.valueCountry.title
                      : ""
                  }&polygon_geojson=1&format=jsonv2`;
                  fetch(url)
                    .then(function (response) {
                      return response.json();
                    })
                    .then(function (json) {
                      setZoomCenter({
                        Lat: parseFloat(json[0].lat),
                        Lng: parseFloat(json[0].lon),
                      });
                      setLocationData({
                        Lat: "",
                        Lng: "",
                      });
                      setMapBorder(json[0].geojson);

                      if (x.valueCity && x.valueCity.title !== null) {
                        setZoom(12);
                      } else if (
                        x.valueProvince &&
                        x.valueProvince.title !== null
                      ) {
                        setZoom(8);
                      } else if (x.valueCountry.title !== null) {
                        setZoom(3);
                      }
                      setMapLoading(true);
                    });
                } else {
                  console.log("geolocation");

                  if ("geolocation" in navigator) {
                    console.log("geolocation is Available");

                    navigator.geolocation.getCurrentPosition(
                      function (position) {
                        console.log("geolocation is:");

                        console.log("Latitude is :", position.coords.latitude);
                        console.log(
                          "Longitude is :",
                          position.coords.longitude
                        );

                        setLocationData({
                          Lat: position.coords.latitude,
                          Lng: position.coords.longitude,
                        });
                        setZoom(16);
                      },
                      function (error) {
                        console.error(
                          "geolocation Error Code = " +
                            error.code +
                            " - " +
                            error.message
                        );
                      }
                    );
                  } else {
                    console.log("geolocation is Not Available");
                  }

                  setMapLoading(true);
                }
              }
            }
          }
        })
        .catch((error) => {
          // alert(error);
        });

      axios
        .get(configData.API_DOMAIN + "/api/v1/Countries", {
          headers: header,
        })
        .then((response) => {
          if (response.data.isSuccess) {
            setCountries(response.data.data);
          } else {
            setCountries([]);
          }
        })
        .catch((error) => {
          // alert(error);
        });
      // }
      setRender(true);
      // }
      // comment for come data from mina -- check api
      // }
      // }
      // })
      // .catch((error) => {
      //   // alert(error);
      // });
      // comment for come data from mina -- check api
    }
  }, []);

  useEffect(() => {
    if (inputValueCountry != "") {
      setMapLoading(false);
      // setZoomCenter({
      //   Lat: "",
      //   Lng: "",
      // });

      axios
        .get(configData.API_DOMAIN + `/api/v1/Provinces/${CountryId}`, {
          headers: {
            ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
            LangId: 1,
            Authorization: "Bearer " + getCookie("token"),
          },
        })
        .then((response) => {
          if (response.data.isSuccess) {
            setProvinces(response.data.data);
          } else {
            setProvinces([]);
          }
        })
        .catch((error) => {
          // alert(error);
        });
      // let url = `https://nominatim.openstreetmap.org/search.php?q=${inputValueCountry}&polygon_geojson=1&format=jsonv2`;
      let url = `https://nominatim.openstreetmap.org/search.php?city=&county=&state=&country=${
        inputValueCountry !== undefined ? inputValueCountry : ""
      }&polygon_geojson=1&format=jsonv2`;
      fetch(url)
        .then(function (response) {
          return response.json();
        })
        .then(function (json) {
          setZoomCenter({
            Lat: parseFloat(json[0].lat),
            Lng: parseFloat(json[0].lon),
          });
          setLocationData({
            Lat: "",
            Lng: "",
          });
          setZoom(3);
          setMapBorder(json[0].geojson);
          setMapLoading(true);
        });
    }
  }, [CountryId]);

  useEffect(() => {
    if (
      inputValueProvince != "" &&
      inputValueCountry != "" &&
      valueProvince != null
    ) {
      // setZoomCenter({
      //   Lat: "",
      //   Lng: "",
      // });

      setMapLoading(false);

      axios
        .get(configData.API_DOMAIN + `/api/v1/Cities/${ProvinceId}`, {
          headers: {
            ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
            LangId: 1,
            Authorization: "Bearer " + getCookie("token"),
          },
        })
        .then((response) => {
          if (response.data.isSuccess) {
            setCities(response.data.data);
          } else {
            setCities([]);
          }
        })
        .catch((error) => {
          // alert(error);
        });

      // let url = `https://nominatim.openstreetmap.org/search.php?q=${
      //   inputValueCountry !== undefined ? inputValueCountry : ""
      // } ${inputValueProvince !== undefined ? inputValueProvince : ""} ${
      //   inputValueCity !== undefined ? inputValueCity : ""
      // }
      // &polygon_geojson=1&format=jsonv2`;
      let url = `https://nominatim.openstreetmap.org/search.php?city=${
        inputValueCity !== undefined ? inputValueCity : ""
      }&county=&state=${
        inputValueProvince !== undefined ? inputValueProvince : ""
      }&country=${
        inputValueCountry !== undefined ? inputValueCountry : ""
      }&polygon_geojson=1&format=jsonv2`;
      fetch(url)
        .then(function (response) {
          return response.json();
        })
        .then(function (json) {
          setZoomCenter({
            Lat: parseFloat(json[0].lat),
            Lng: parseFloat(json[0].lon),
          });
          setLocationData({
            Lat: "",
            Lng: "",
          });
          setZoom(8);
          setMapBorder(json[0].geojson);
          setMapLoading(true);
        });
    }
  }, [ProvinceId]);

  useEffect(() => {
    if (
      inputValueCountry != "" &&
      inputValueProvince != "" &&
      valueProvince != null &&
      inputValueCity != "" &&
      valueCity != null
    ) {
      // setZoomCenter({
      //   Lat: "",
      //   Lng: "",
      // });

      setMapLoading(false);

      // let url = `https://nominatim.openstreetmap.org/search.php?q=${
      //   inputValueCountry !== undefined ? inputValueCountry : ""
      // } ${inputValueProvince !== undefined ? inputValueProvince : ""} ${
      //   inputValueCity !== undefined ? inputValueCity : ""
      // }
      // &polygon_geojson=1&format=jsonv2`;
      let url = `https://nominatim.openstreetmap.org/search.php?city=${
        inputValueCity !== undefined ? inputValueCity : ""
      }&county=&state=${
        inputValueProvince !== undefined ? inputValueProvince : ""
      }&country=${
        inputValueCountry !== undefined ? inputValueCountry : ""
      }&polygon_geojson=1&format=jsonv2`;
      fetch(url)
        .then(function (response) {
          return response.json();
        })
        .then(function (json) {
          setZoomCenter({
            Lat: parseFloat(json[0].lat),
            Lng: parseFloat(json[0].lon),
          });
          setLocationData({
            Lat: "",
            Lng: "",
          });
          setZoom(12);
          setMapBorder(json[0].geojson);
          setMapLoading(true);
        });
    }
  }, [valueCity]);

  //   getCookie
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  return (
    <>
      {render ? (
        <>
          {MTagsCome ? <MetaTagsBusinessOwners data={MetaData} /> : ""}

          <RegisterBusiness />
          <div>
            <MDBRow className="mx-0">
              <div className="col-12 col-md-8 register-business-padd">
                <div className="register-steps-right">
                  <h1 className="rb-step3-tit1">
                    آدرس کسب‌و‌کار خود را وارد کنید
                  </h1>
                  <CacheProvider value={cacheRtl}>
                    <ThemeProvider theme={theme}>
                      {dataCome ? (
                        <>
                          <div dir="rtl" className="mb-step3">
                            <div className="d-md-flex">
                              <div className=" auto9 width-sm-100 mb-3 ms-md-3 list-left">
                                <Autocomplete
                                  // open={true}
                                  value={valueCountry}
                                  onChange={(event, newValue) => {
                                    setValueCountry(newValue);
                                    setProvinces([]);
                                    setCities([]);
                                    setValueProvince(null);
                                    setValueCity(null);
                                    setCountryId(newValue.id);
                                    setInputDisable(false);
                                    setPostalCode(newValue.postalStd);
                                    setData({
                                      ...data,
                                      PostalCode: "",
                                      country: newValue.title,
                                    });

                                    setPhoneCode(newValue.phoneStd);
                                    setProvinceId("");
                                  }}
                                  inputValue={inputValueCountry}
                                  onInputChange={(event, newInputValue) => {
                                    var result = newInputValue.replace(
                                      /[^A-Za-z\s,]/gi,
                                      ""
                                    );
                                    setInputValueCountry(result);
                                    // setData({
                                    //   ...data,
                                    //   country: newInputValue,
                                    // });
                                  }}
                                  popupIcon={
                                    <img
                                      src={iconn}
                                      className="icon-ib"
                                      alt="category img"
                                    />
                                  }
                                  disableClearable
                                  disablePortal
                                  openOnFocus={true}
                                  id="auto8"
                                  options={Countries}
                                  getOptionLabel={(option) => option.title}
                                  className=""
                                  sx={{
                                    fontFamily: "inherit",
                                  }}
                                  renderInput={(params) => (
                                    <div className="d-flex width-sm-100">
                                      <TextField
                                        id="auto8"
                                        className={
                                          errors.country && touched.country
                                            ? "auto-error font-family-en"
                                            : "mb-3 font-family-en"
                                        }
                                        {...params}
                                        label="کشور"
                                        required
                                      >
                                        {" "}
                                      </TextField>
                                    </div>
                                  )}
                                />
                                {errors.country && touched.country && (
                                  <span className="input-error-auto me-1">
                                    {errors.country}
                                  </span>
                                )}
                              </div>
                              <div className=" auto9 width-sm-100 mb-3 ms-md-3 list-left">
                                <Autocomplete
                                  // open={true}
                                  // value={data.province}
                                  value={valueProvince}
                                  onChange={(event, newValue) => {
                                    setProvinceId(newValue.id);

                                    setValueProvince(newValue);
                                    setCities([]);
                                    setValueCity(null);
                                  }}
                                  inputValue={inputValueProvince}
                                  onInputChange={(event, newInputValue) => {
                                    var result = newInputValue.replace(
                                      /[^A-Za-z\s,]/gi,
                                      ""
                                    );
                                    setInputValueProvince(result);
                                    setData({
                                      ...data,
                                      province: result,
                                    });
                                  }}
                                  // onChange={(event, newValue) => {
                                  //   setData({
                                  //     ...data,
                                  //     province: newValue.ProvinceName,
                                  //   });
                                  //   setProvinceId(newValue.Id);
                                  // }}
                                  popupIcon={
                                    <img
                                      src={iconn}
                                      className="icon-ib"
                                      alt="category img"
                                    />
                                  }
                                  disabled={inputDisable}
                                  disableClearable
                                  disablePortal
                                  openOnFocus={true}
                                  id="auto8"
                                  options={Provinces}
                                  getOptionLabel={(option) => option.title}
                                  className=""
                                  sx={{
                                    fontFamily: "inherit",
                                  }}
                                  renderInput={(params) => (
                                    <div className="d-flex width-sm-100">
                                      <TextField
                                        id="auto8"
                                        className={
                                          "mb-3 label-field-more font-family-en"
                                        }
                                        {...params}
                                        label={"استان / ایالت "}
                                      >
                                        {" "}
                                      </TextField>
                                    </div>
                                  )}
                                />
                              </div>
                            </div>
                            <div
                              className={
                                ErrorPostalCode !== ""
                                  ? "d-md-flex mb_12_new"
                                  : "d-md-flex"
                              }
                            >
                              <div className=" auto9 width-sm-100 mb-3 ms-md-3 list-left">
                                <Autocomplete
                                  // open={true}
                                  // value={data.city}
                                  // onChange={(event, newValue) => {
                                  //   setData({ ...data, city: newValue.CityName });
                                  // }}
                                  value={valueCity}
                                  onChange={(event, newValue) => {
                                    setValueCity(newValue);
                                  }}
                                  inputValue={inputValueCity}
                                  onInputChange={(event, newInputValue) => {
                                    var result = newInputValue.replace(
                                      /[^A-Za-z\s,]/gi,
                                      ""
                                    );
                                    setInputValueCity(result);
                                    setData({ ...data, city: result });
                                  }}
                                  popupIcon={
                                    <img
                                      src={iconn}
                                      className="icon-ib"
                                      alt="category img"
                                    />
                                  }
                                  disabled={inputDisable}
                                  disableClearable
                                  disablePortal
                                  openOnFocus={true}
                                  id="auto8"
                                  options={Cities}
                                  getOptionLabel={(option) => option.title}
                                  className=""
                                  sx={{
                                    fontFamily: "inherit",
                                  }}
                                  renderInput={(params) => (
                                    <div className="d-flex width-sm-100">
                                      <TextField
                                        id="auto8"
                                        className={"mb-3 font-family-en"}
                                        {...params}
                                        label="شهر"
                                      >
                                        {" "}
                                      </TextField>
                                    </div>
                                  )}
                                />
                              </div>

                              <div className="d-md-none">
                                <div className="mb-3 ms-md-3">
                                  <TextField
                                    disabled={inputDisable}
                                    dir="ltr"
                                    type="text"
                                    value={data.AddressLine1}
                                    onChange={CheckAddress}
                                    id="outlined-basic"
                                    label="آدرس"
                                    variant="outlined"
                                    className={
                                      "label-field-more7 custom-text-field custom-text-field-contact mb-0 font-family-en"
                                    }
                                  />
                                </div>
                                <div className="mb-3">
                                  <TextField
                                    disabled={inputDisable}
                                    dir="ltr"
                                    type="text"
                                    id="outlined-basic"
                                    value={data.AddressLine2}
                                    label="پلاک و واحد"
                                    variant="outlined"
                                    onChange={(event) =>
                                      setData({
                                        ...data,
                                        AddressLine2: event.target.value,
                                      })
                                    }
                                    className={
                                      "label-field-more7 custom-text-field custom-text-field-contact mb-0 font-family-en"
                                    }
                                  />
                                </div>
                              </div>

                              <div className="mb-0">
                                <InputMask
                                  formatChars={formatChar}
                                  mask={PostalCode}
                                  // maskChar={null}
                                  value={data.PostalCode}
                                  onChange={PostalHandeler}
                                  disabled={inputDisable}
                                >
                                  {(inputProps) => (
                                    <TextField
                                      disabled={inputDisable}
                                      dir="ltr"
                                      id="outlined-basic"
                                      label="کد پستی"
                                      variant="outlined"
                                      onChange={PostalHandeler}
                                      className={
                                        ErrorPostalCode !== ""
                                          ? "label-field-more10 custom-text-field custom-text-field-contact font-family-en mb-0 width20vw custom-text-field-error "
                                          : "label-field-more10 custom-text-field custom-text-field-contact font-family-en mb-0 width20vw  "
                                      }
                                      {...inputProps}
                                    />
                                  )}
                                </InputMask>
                                {ErrorPostalCode !== "" && (
                                  <span className="input-error-auto me-1 mb-1">
                                    {ErrorPostalCode}
                                  </span>
                                )}
                              </div>
                              <br />
                            </div>
                            <div className="d-none d-md-block">
                              <div className="mb-3 ms-md-3">
                                <TextField
                                  disabled={inputDisable}
                                  dir="ltr"
                                  type="text"
                                  value={data.AddressLine1}
                                  onChange={CheckAddress}
                                  id="outlined-basic"
                                  label="آدرس"
                                  variant="outlined"
                                  className={
                                    "label-field-more7 custom-text-field custom-text-field-contact mb-0 font-family-en"
                                  }
                                />
                              </div>
                              <div className="mb-3">
                                <TextField
                                  disabled={inputDisable}
                                  dir="ltr"
                                  type="text"
                                  id="outlined-basic"
                                  label="پلاک و واحد"
                                  variant="outlined"
                                  value={data.AddressLine2}
                                  onChange={(event) =>
                                    setData({
                                      ...data,
                                      AddressLine2: event.target.value,
                                    })
                                  }
                                  className={
                                    "label-field-more7 custom-text-field custom-text-field-contact mb-0 font-family-en"
                                  }
                                />
                              </div>
                            </div>
                            <br />
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="d-md-flex width-42vw width-sm-100">
                            <Skeleton
                              className="profile-Skeleton ms-3"
                              variant="rectangular"
                              height={30}
                              animation="wave"
                            />
                            <Skeleton
                              className="profile-Skeleton mt-3 mt-md-0 "
                              variant="rectangular"
                              height={30}
                              animation="wave"
                            />
                          </div>
                          <div className="d-md-flex width-42vw width-sm-100">
                            <Skeleton
                              className="profile-Skeleton mt-3 ms-3"
                              variant="rectangular"
                              height={30}
                              animation="wave"
                            />
                            <Skeleton
                              className="profile-Skeleton mt-3 "
                              variant="rectangular"
                              height={30}
                              animation="wave"
                            />
                          </div>
                          <Skeleton
                            className="profile-Skeleton mt-3"
                            variant="rectangular"
                            height={30}
                            animation="wave"
                          />
                          <Skeleton
                            className="profile-Skeleton mt-3"
                            variant="rectangular"
                            height={30}
                            animation="wave"
                          />
                        </>
                      )}
                    </ThemeProvider>
                  </CacheProvider>
                  <p className="map-disc">
                    لطفا لوکیشن خود را روی نقشه مشخص کنید تا در نتایج جست‌وجو
                    بهتر دیده شوید.
                  </p>
                  <div className="d-md-none">
                    <DraggableMap
                      loc="step4"
                      zoom={zoom}
                      setZoom={setZoom}
                      locationData={locationData}
                      setLocationData={setLocationData}
                      country={inputValueCountry}
                      state={inputValueProvince}
                      city={inputValueCity}
                      postalCode={data.PostalCode}
                      zoomCenter={zoomCenter}
                      setZoomCenter={setZoomCenter}
                      mapBorder={mapBorder}
                      mapLoading={mapLoading}
                    />
                  </div>
                  <div className="mt-5">
                    {dataCome ? (
                      <div className="rb-steps-btns">
                        <Link
                          // to="/register-business-step3"
                          className="rb-steps-btn1 hov-shadow"
                          onClick={backHandler}
                        >
                          مرحله قبلی
                        </Link>
                        <MDBBtn
                          disabled={disable}
                          onClick={submitHandler}
                          className="rb-steps-btn2 hov-shadow"
                        >
                          مرحله بعدی
                        </MDBBtn>
                      </div>
                    ) : (
                      <div className="rb-steps-btns">
                        <Skeleton
                          className="rb-steps-btn2 h-Skeleton-39"
                          variant="rectangular"
                          width={123}
                          height={39}
                          animation="wave"
                        />
                        <Skeleton
                          className="rb-steps-btn2 h-Skeleton-39"
                          variant="rectangular"
                          width={123}
                          height={39}
                          animation="wave"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-4 px-0 text-center d-md-block d-none">
                {/* <img
                  className="register-business-img044"
                  src={imgg}
                  alt="register business"
                /> */}

                {/* {dataCome ? ( */}
                <DraggableMap
                  loc="step4"
                  zoom={zoom}
                  setZoom={setZoom}
                  locationData={locationData}
                  setLocationData={setLocationData}
                  country={inputValueCountry}
                  state={inputValueProvince}
                  city={inputValueCity}
                  postalCode={data.PostalCode}
                  zoomCenter={zoomCenter}
                  setZoomCenter={setZoomCenter}
                  mapBorder={mapBorder}
                  mapLoading={mapLoading}
                />
                {/* // ) : (
                //   <></>
                // )} */}
              </div>
            </MDBRow>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};
// const categories = [
//   { label: "Canada", year: 1, Postal: "*** ***" },
//   { label: "America", year: 2, Postal: "9999" },
// ];
// const cities = [
//   { label: "Torento", year: 1 },
//   { label: "Torento", year: 2 },
// ];

export default RegisterBusinessStep3;
